import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-booking-type-simple',
  templateUrl: './booking-type-simple.component.html',
  styleUrls: ['./booking-type-simple.component.css']
})
export class BookingTypeSimpleComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  url: string;

  constructor(protected router: Router) { }

  ngOnInit() {
  }

  onClick() {
    if (this.url) {
      this.router.navigateByUrl(this.url);
    }
  }

}
